import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="py-16 px-4 bg-red-50 border-y border-red-200" data-id="element-206">
      <div className="max-w-3xl mx-auto text-center" data-id="element-207">
        <h2 className="text-2xl md:text-3xl font-bold text-warm-900 mb-6" data-id="element-208">
          Esta oferta especial termina cuando el contador llegue a cero
        </h2>

        <div className="bg-white p-8 rounded-2xl border border-red-200 shadow-sm inline-block" data-id="element-209">
          <CountdownTimer variant="section" data-id="element-210" />
        </div>
      </div>
    </section>;
}